module.exports = __webpack_public_path__ + "img/users.f4447bdf.svg";